module.exports = __webpack_public_path__ + "static/media/ckri.bf773280.png";